export const FIELD_VERIFY_ERROR_GAP_PX = 6
export const FIELD_VERIFY_ERROR_INSET_PX = 8

export type FieldVerifyErrorPlacement = 'above' | 'below'

export type FieldVerifyErrorAnchor = {
  top: number
  left: number
  width: number
  height: number
  bottom: number
}

export type FieldVerifyErrorBox = {
  top: number
  left: number
  maxWidth: number
  placement: FieldVerifyErrorPlacement
}

/** Prefer above the field; flip below when the top gap is too small. Stay inside the viewport. */
export function placeFieldVerifyErrorOverlay(args: {
  anchor: FieldVerifyErrorAnchor
  balloonHeight: number
  viewport: { width: number; height: number }
  gapPx?: number
  insetPx?: number
}): FieldVerifyErrorBox {
  const gap = args.gapPx ?? FIELD_VERIFY_ERROR_GAP_PX
  const inset = args.insetPx ?? FIELD_VERIFY_ERROR_INSET_PX
  const vw = args.viewport.width
  const vh = args.viewport.height
  const balloonHeight = Math.max(0, args.balloonHeight)
  const spaceAbove = args.anchor.top - inset
  const placement: FieldVerifyErrorPlacement =
    balloonHeight + gap <= spaceAbove ? 'above' : 'below'

  const maxWidth = Math.max(0, Math.min(args.anchor.width, Math.max(0, vw - inset * 2)))
  const maxLeft = Math.max(inset, vw - inset - maxWidth)
  const left = Math.min(Math.max(args.anchor.left, inset), maxLeft)

  const rawTop =
    placement === 'above'
      ? args.anchor.top - gap - balloonHeight
      : args.anchor.bottom + gap
  const maxTop = Math.max(inset, vh - inset - balloonHeight)
  const top = Math.min(Math.max(rawTop, inset), maxTop)

  return { top, left, maxWidth, placement }
}
